<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="700"
    >      
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Replace or Skip Data 
        </v-card-title>

        <v-card-text>
           Your update data has clashed with your server data that uptodate by other user. Please choose your action !<br/>
            <v-alert
                :value="true"
                color="success"
                icon="check_circle"
                outline
            >
               {{dataA}}
            </v-alert>

              <v-alert
                :value="true"
                color="info"
                icon="info"
                outline
              >
               {{dataB}}
              </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            flat
            @click="replace"
          >
            Replace the data using server update
          </v-btn>
          
          <v-btn
            color="primary"
            flat
            @click="skipped"
          >
            Skip server update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>    
import moment  from 'moment';
import Models  from '@/util/models'

let model = new Models();

export default {
    name: 'widget-fetch', 
    data () {
        return {
            dialog  : false,
            dataA : '',
            dataB: '',
            obj :null
        }
    },
    created () { 
        
        window.getApp.$on('APP_OPEN_FETCH', (obj) => {
            this.obj = obj;
            this.dialog = true;                        
            this.dataB = this.toStr(obj.item);
            this.dataA = this.toStr(obj.item.info.data);            
        });  
    },
    methods: {
        toStr(obj){
            var excepted = ['$id','time','info','flag','deleted'];
            var msg = '';
            for(var key in obj){
                if(!this.inArray(key, excepted) && !this.isObject(obj[key]) && !this.isFunction(obj[key])){                    
                    msg += key+' : '+obj[key]+', ';                    
                }                
            }
            return msg;
        },
        
        inArray(needle, haystack = []) {
            var length = haystack.length;
            for(var i = 0; i < length; i++) {
                if(typeof haystack[i] == 'object') {
                    if(arrayCompare(haystack[i], needle)) return true;
                } else {
                    if(haystack[i] == needle) return true;
                }
            }
            return false;
        },
        
        isObject (item) {
            return (typeof item === "object" && !Array.isArray(item) && item !== null);
        },
        
        isFunction(functionToCheck) {
            return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
        },
        
        replace(){
            var data = this.obj.item;
            data.info.data.flag = null;
            model.updateOffline(data.info.db, data.info.data);  
            this.dialog = false; 
        },
        
        skipped(){
            var db    =  this.obj.item.info.db;
            var data  =  this.obj.item;
            data.info =  null;
            data.flag = 'update';
            //console.log(db);
            model.updateOffline(db, data);
            this.dialog = false; 
        }        
    }
}    
</script>